export const ProductCreatePage = () => {
  return (
    <>
      <div>제품 관리용 페이지</div>
    </>
  );
};

export default ProductCreatePage;
